import React from 'react';
import {FlagChecker} from './flagchecker.js';

class App extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      flagged: "..."
    };
  }
    
  flagChecker(event){
    let potentialFlag = event.target.value;
    
    this.setState({"flagged": FlagChecker(potentialFlag)});
  }

  render(){
    return (
      <div>
        <div>
	 <input type="test" onChange={this.flagChecker.bind(this)}/>
	 <h2>{this.state.flagged}</h2>
        </div>
      </div>
    )
  }
}

export default App;
